<template>
<div class="chapter">
<div class="inner_page">
<p class="bk" id="d6e384">The Summer Snow </p>
<hr/>
<p class="ct" id="d6e434"><br/><br/><br/>Rebecca Pawel <br/><br/><br/><br/><br/><br/><br/><br/></p>
<p class="ser"><img alt="978-1-56947-443-3-4" id="d14e52" src="images/978-1-56947-443-3-4.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Pawe_9781569477786_epub_c4_r1.vue?42cfd315